        

    <div class="flex items-center justify-center" style="height: calc(100vh - 100px); ">  

      <!-- <app-solar-system></app-solar-system> -->
      
      <img 
        src="./../../../../assets/img/LogoONe-trans.png" alt="ON LOGO"   
        style="width: 40%; height: auto;"/> 
    </div>  